import { Button } from "@/overlay/components/CommonParts/buttons";
import { ColorPickerInput } from "@/overlay/components/LayerStackWindow/LayerFormElements";
import { FormField } from "@/overlay/components/form-field";
import { t } from "@lingui/core/macro";
import { MmTooltipWrapper } from "@mm/zeus-react";
import React from "react";
import styles from "./AdvancedThreshold.module.scss";

export type AdvancedThresholdHeaderProps = {
  color: string;
  label: string;
  onColorChange: (color: string) => void;
  onLabelChange: (newLabel: string) => void;
  onDelete: () => void;
};

export const AdvancedThresholdHeader = (props: AdvancedThresholdHeaderProps) => {
  const { color, label, onLabelChange, onColorChange, onDelete } = props;

  return (
    <div className={styles.advancedThresholdHeader}>
      <FormField
        label={t`Threshold Title`}
        alignTop={true}
        background={false}
        className={styles.customFormField}
        removePadding={true}
      >
        <input
          value={label}
          onChange={({ target: { value } }) => {
            onLabelChange(value);
          }}
        />
      </FormField>
      <ColorPickerInput
        label={"Result Color"}
        value={color}
        change={onColorChange}
        data-testid={"color-picker"}
        formFieldOptions={{ background: false, alignTop: true }}
      />
      <MmTooltipWrapper tail={true} position="top-left" tooltip-text={t`Delete`}>
        <Button data-testid="layer-delete-button" icon="delete_outline" onClick={onDelete} />
      </MmTooltipWrapper>
    </div>
  );
};
